// resources/js/mixins/leadTimeMixin.js

export default {
    methods: {
      /**
       * Format a JS Date as YYYY-MM-DD
       */
      formatDate(d) {
        if (!(d instanceof Date)) d = new Date(d);
        const m = ('0' + (d.getMonth() + 1)).slice(-2);
        const day = ('0' + d.getDate()).slice(-2);
        return `${d.getFullYear()}-${m}-${day}`;
      },
  
      /**
       * Core business-day calculator.
       * - Skips weekends
       * - Skips holidays from this.holidays (array of 'YYYY-MM-DD')
       * - If after 2pm CST, bumps start date by 1 business day.
       */
      getCurrentDate(total, passDate = null) {
        let e;
  
        if (passDate) {
          e = new Date(passDate);
        } else {
          e = new Date();
          const options = {
            timeZone: 'America/Chicago',
            hour12: false,
            hour: 'numeric'
          };
          const hourCST = parseInt(e.toLocaleString('en-US', options), 10);
  
          // After 2pm CST, start from next day
          if (hourCST >= 14) {
            e.setDate(e.getDate() + 1);
          }
        }
  
        const holidays = this.holidays || [];
  
        for (let i = 0; i < total - 1; i++) {
          // Skip weekends
          if (e.getDay() === 0 || e.getDay() === 6) {
            i--;
          } else if (holidays.length) {
            const dStr = this.formatDate(e);
            if (holidays.indexOf(dStr) > -1) {
              i--;
            }
          }
  
          // If Friday, jump to Monday; else add 1 day
          if (e.getDay() === 5) {
            e.setDate(e.getDate() + 3);
          } else {
            e.setDate(e.getDate() + 1);
          }
        }
  
        return e;
      },
  
      /**
       * Bumps calcDate up if any color/size active_date is later.
       */
      checkColorsDates(item, calcDate) {
        if (!calcDate) return calcDate;
  
        let result = calcDate instanceof Date ? calcDate : new Date(calcDate);
  
        (item.order_item_colors || []).forEach((color) => {
          (color.sizes || []).forEach((size) => {
            if (size.quantity && size.active_date) {
              const e = new Date(size.active_date);
              if (e > result) {
                result = e;
              }
            }
          });
  
          (color.inner_colors || []).forEach((c) => {
            (c.sizes || []).forEach((size) => {
              if (size.quantity && size.active_date) {
                const e = new Date(size.active_date);
                if (e > result) {
                  result = e;
                }
              }
            });
          });
        });
  
        return result;
      },
  
      /**
       * For a single item, determine the base calc date from:
       * - max(location.technique.lead_time, program.days_out)
       * - or 3 days for blank orders
       */
      getCalcDate(item) {
        if (!item) return '';
  
        let calcDate = '';
        let total = '';
  
        if (!item.blank_order) {
          (item.order_item_locations || []).forEach((location) => {
            if (!location.technique) return;
  
            if (total === '') {
              total = parseInt(location.technique.lead_time);
              if (total < parseInt(item.program_info.days_out)) {
                total = parseInt(item.program_info.days_out);
              }
            } else if (total < parseInt(item.program_info.days_out)) {
              // This line in your old code referenced location.order.program_info;
              // here we just keep using item.program_info.
              total = parseInt(item.program_info.days_out);
            } else if (total < parseInt(location.technique.lead_time)) {
              total = parseInt(location.technique.lead_time);
            }
          });
  
          if (total !== '') {
            const totalInt = parseInt(total);
            calcDate = this.getCurrentDate(totalInt);
          } else {
            calcDate = '';
          }
        } else {
          // Blank order default: 3 business days
          calcDate = this.getCurrentDate(3);
        }
  
        calcDate = this.checkColorsDates(item, calcDate);
        return calcDate;
      },
  
      /**
       * Old "Ship ASAP" logic for a single item:
       * - getCalcDate
       * - +1 day
       * - skip weekends & holidays
       * returns YYYY-MM-DD
       */
      getShipAsapDate(item) {
        const calcDate = this.getCalcDate(item);
        if (!calcDate) return '';
  
        const holidays = this.holidays || [];
        let date = calcDate instanceof Date ? new Date(calcDate) : new Date(calcDate);
  
        // Add 1 day initially
        date.setDate(date.getDate() + 1);
  
        while (
          date.getDay() === 0 || // Sunday
          date.getDay() === 6 || // Saturday
          (holidays.length && holidays.includes(this.formatDate(date)))
        ) {
          date.setDate(date.getDate() + 1);
        }
  
        return this.formatDate(date);
      }
    }
  };
  